import { h, Fragment } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import Image from 'utils/image';
import Icon from '../utils/icon';
import CartService from '../cart/cart-service';

const ProductSwatchesSamples = ({ 
  currentVariant
}) => {
  const swatchesSamples = currentVariant?.swatchesSamples;
  const numberOfAvailableSwatches = 
  swatchesSamples?.filter(sSample => sSample.productAvailable === true);
  const [cartItems, setCartItems] = useState(CartService?.cart?.items);
  const [selectedSwatches, setSelectedSwatches] = useState([]);

  const swatchItems = cartItems?.filter(
    item => item.product_type === 'Swatch'
  ) || [];
  const numberOfSwatches = 
      (swatchItems.length || 0) + (selectedSwatches?.length || 0);
  const selectedText = numberOfSwatches ? 
  `${numberOfSwatches} ${window.TMW.Strings.product.swatchesSelected}` 
  : window.TMW.Strings.product.makeYourSelection;

  const swiperRef = useRef(null);

  SwiperCore.use([Navigation]);

  const handlePrevClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  }

  const handleNextClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  }

  const SwatchesAddToCartButton = ({ swatchesIds,quantity }) => {
    const swatchesHandleAddToCart = (e) => {
      e.preventDefault();
      const items = swatchesIds.map(swatchId => ({
        merchandiseId: swatchId,
        quantity,
      }));
      const addToCartEvent = new CustomEvent('cart:add', {
        detail: {
          payload: items,
        },
      });
      document.dispatchEvent(addToCartEvent);
      setSelectedSwatches([])
    };
  
    return ( 
      <button
        type="submit"
        className="w-full button button--primary-on-white"
        disabled={selectedSwatches?.length === 0}
        onClick={(e) => swatchesHandleAddToCart(e)}
      >
        {selectedSwatches?.length !== 0
          ? window.TMW.Strings.product.addToCart
          : window.TMW.Strings.product.selectSwatches}
      </button>
    );
  };

  useEffect(() => {
    const updateCartItems = () => {
      setCartItems(CartService.cart.items);
    }
    CartService.addListener(updateCartItems);
    return () => CartService.removeListener(updateCartItems);
  })

  const isInCart = (productId) => {
    const productIdConverted = parseInt(productId.split('/').splice(-1)[0] , 10)
    return cartItems?.some(item => item.id === productIdConverted);
  };

  const handleCheckboxClick = (swatchId) => {
    setSelectedSwatches(prevSelected => {
      if (prevSelected.includes(swatchId)) {
        return prevSelected.filter(id => id !== swatchId);
      } 
      return [...prevSelected, swatchId];
    });
  };

  return (
    <Fragment>
      {numberOfAvailableSwatches.length > 0 && 
        <div className="relative pt-8 pb-5">
        <p className="utility-2 text-primary">
          {window.TMW.Strings.product.yourSwatches}
        </p>
        <p className="body-2 text-secondary">
          {selectedText}
        </p>
        {numberOfAvailableSwatches > 3 && 
          <Fragment>
            <div className='
              cursor-pointer z-10 absolute right-10 top-8' 
              onClick={handlePrevClick}
            >
              <Icon name='arrow-prev'/>
            </div>
            <div className='
              cursor-pointer z-10 absolute right-0 top-8' 
              onClick={handleNextClick}
            >
              <Icon name='arrow-prev' className='rotate-180' />
            </div>
          </Fragment>
        }
        
        <Swiper 
          slidesPerView={3}
          grabCursor={true}
          className='!pt-4 !pb-4'
          spaceBetween={8}
          onSwiper={(swiper) => {
            swiperRef.current = swiper; 
          }}
        >
          {swatchesSamples?.map((swatch,index) => (
            swatch.image.src && swatch.productAvailable && (
              <SwiperSlide key={swatch.productId} className='w-30'> 
                <div className='w-full h-full'>
                  <Image
                    {...swatch.image}
                    srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
                    classes={`w-full h-full object-cover cursor-pointer`}  
                  />
                  <p className='body-2 text-primary pt-2 pb-2'>
                    { swatch.productTitle }
                  </p>
                  <div className='flex items-center gap-2'>
                    <input 
                      type='checkbox' 
                      id={`checkbox-${index}`} 
                      className='swatch-checkbox' 
                      name='checkbox' 
                      value={swatch.productId}
                      {
                        ...(
                          isInCart(swatch.productId) || numberOfSwatches > 9
                        )
                        && { disabled: true }
                      }
                      checked={
                        isInCart(swatch.productId) ? true : 
                        selectedSwatches.includes(swatch.productId)
                      }
                      onChange={() => {
                        handleCheckboxClick(swatch.productId)
                      }}
                    />
                    <label 
                      className={
                        `body-2 
                        ${
                          isInCart(swatch.productId) || 
                          numberOfSwatches > 9 ? 
                          'text-disabled' : 
                          'text-secondary'
                        }`
                      }
                      htmlFor={`checkbox-${index}`}
                    >
                      {window.TMW.Strings.product.select}
                    </label>
                  </div>
                </div>
              </SwiperSlide>
            )
          ))}
        </Swiper>
        <SwatchesAddToCartButton swatchesIds={selectedSwatches} quantity={1}/>
      </div>
      }
    </Fragment>
  )
};

export default ProductSwatchesSamples;